import React, { memo, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useMutation } from "@apollo/client";
import { Input, InputVertical } from '../../../../../_metronic/_partials/controls';
import { Field, Formik } from 'formik';
import * as Yup from "yup";
import { useToasts } from 'react-toast-notifications';
import { useIntl } from "react-intl";
import mutate_userCreateBrand from '../../../../../graphql/mutate_userCreateBrand';

const ModalAddBrand = ({
    onHide,
    isShow
}) => {
    const {formatMessage} = useIntl()
    const _form = useRef(null)
    const [mutate, { loading }] = useMutation(mutate_userCreateBrand, {
        refetchQueries: ['sme_brands', 'sme_brands_aggregate'],
    })
    const { addToast } = useToasts();

    useEffect(() => {
        if (!isShow) {
            !!_form.current && _form.current.resetForm()
        }
    }, [isShow])
    return (
        <Formik
            initialValues={{
                name: ''
            }}
            onSubmit={async (values) => {
                let {data} = await mutate({
                    variables: {
                        userCreateBrandInput: {
                            name: values?.name || ''
                        }
                    }
                })
                if(data?.userCreateBrand?.success) {
                    addToast(formatMessage({defaultMessage:'Tạo nhãn hàng thành công.'}), { appearance: 'success' });
                } else {
                    addToast(data?.userCreateBrand?.message || formatMessage({defaultMessage:'Tạo nhãn hàng thất bại.'}), { appearance: 'error' });
                }
                onHide()
            }}
            validationSchema={Yup.object().shape({
                name: Yup.string()
                    .max(120, formatMessage({ defaultMessage: "{name} tối đa {length} ký tự" }, { length: 120, name: formatMessage({ defaultMessage: "Tên nhãn hàng" }) }))
                    .required(formatMessage({ defaultMessage: "Vui lòng nhập {name}" }, { name: formatMessage({ defaultMessage: "tên nhãn hàng" }).toLowerCase() }))
                    .test(
                        'chua-ky-tu-space-o-dau-cuoi',
                        formatMessage({ defaultMessage: 'Tên nhãn hàng không được chứa dấu cách ở đầu và cuối' }),
                        (value, context) => {
                        if (!!value) {
                            return value.length == value.trim().length;
                        }
                        return false;
                        },
                    )
                    .test(
                        'chua-ky-tu-2space',
                        formatMessage({ defaultMessage: 'Tên nhãn hàng không được chứa 2 dấu cách liên tiếp' }),
                        (value, context) => {
                        if (!!value) {
                            return !(/\s\s+/g.test(value))
                        }
                        return false;
                        },
                    ),
            })}
            innerRef={_form}
        >
            {({
                handleSubmit,
                values,
                validateForm,
                setFieldError,
                submitForm,
            }) => {
                return (
                    <Modal
                        show={isShow}
                        aria-labelledby="example-modal-sizes-title-sm"
                        dialogClassName="modal-show-connect-product"
                        centered
                        onHide={onHide}
                        backdrop={true}

                    >
                        <Modal.Header closeButton={true}>
                            <Modal.Title>
                                {formatMessage({defaultMessage:"Thêm mới nhãn hàng"})}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="overlay overlay-block cursor-default">
                            <div className='row d-flex align-items-center'>
                                <div className='col-4'>
                                    {formatMessage({defaultMessage: 'Tên nhãn hàng'})}
                                </div>
                                <div className='col-8' >
                                    <Field
                                        name="name"
                                        component={InputVertical}
                                        placeholder="Điền tên nhãn hàng"
                                        required
                                        customFeedbackLabel={' '}
                                        countChar
                                        maxChar={120}
                                    />
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="form" style={{ borderTop: '1px solid #dbdbdb', justifyContent: 'end', paddingTop: 10, paddingBottom: 10 }} >
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-secondary btn-elevate mr-3"
                                disabled={loading}
                            >
                                {formatMessage({defaultMessage:"Huỷ bỏ"})}
                            </button>
                            <button
                                type="button"
                                onClick={handleSubmit}
                                className="btn btn-primary btn-elevate"
                                disabled={loading || !values?.name}
                            >
                                {formatMessage({defaultMessage:"Tạo nhãn hàng"})}
                            </button>
                        </Modal.Footer>
                    </Modal>
                )
            }
            }
        </Formik>
    )
};

export default memo(ModalAddBrand);